import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';
import './teachers-list.scss';
import { ImageConstants, AccessRights, Constants } from '../../constants/constants';
import { getImageSource } from '../../utility/image-source';
import AddNewContact from './add-new-contact/add-new-contact'
import SchoolApi from '../../apis/school'
import CWConfirm from '../common/cw-confirmation-modal/cw-confirmation-modal'
import CWClassSection from './add-class-section/add-class-section'
import ContactBulkImport from '../contacts/contact-bulk-import/contact-bulk-import'
import SessionCache from '../routes/session-cache';
import { Modal, ModalBody } from "reactstrap";
import DeleteTeacher from './delete-teacher/delete-teacher'
import InviteTeachers from './invite-teachers-v2/invite-teachers-v2';
import FilterComponent from './filter/filter';
import SchoolUserApi from '../../apis/student';
import Dropdown from '../common/dropdown-v2/dropdown';
import SetupSection from '../class/setup-section/setup-section';
import ToasterComponent from '../common/cw-toaster-component/cw-toaster-component';
const REJECT_REASONS = [
    { title: "NOT_SCHOOL_USER", value: "Not School Users" },
    { title: "ALREADY_EXISTS", value: "Already Exists" }
]
class Teachers extends Component {

    state = {
        adminUsers: [],
        classes: [],
        boards: [],
        isValidForm: false
    }
    filter = {}
    accessRights = SessionCache.getAllowedModule()
    user = SessionCache.getUser()

    componentDidMount() {
        let userInfo = SessionCache.getUser()
        this.setState({ userInfo })
        this.getStaffs(this.filter)
        this.getClasses();
        document.addEventListener('mousedown', this.handleClickEvent, false);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickEvent, false);
    }

    onSelect = (option, key) => {
        this.setState({ [key]: option }, _ => {
            this.validatePayload()
        })
    }

    onChangeHandler = (event, key) => {
        this.setState({ [key]: event.target.value }, _ => {
            this.validatePayload()
        })
    }

    validatePayload = _ => {
        this.setState({
            isValidForm: false
        })
        if (!this.state.rejectReason) return false
        if (!this.state.rejectDetails) return false
        this.setState({
            isValidForm: true
        })
        return true
    }

    onRejectSubmit = _ => {
        this.setState({ showError: true })
        let isValid = this.validatePayload()
        if (!isValid) {
            this.setState({
                errorMessage: "Reject Reason and Message are required fields"
            })
            return
        }
        this.setState({ isSubmit: true })
        this.onDeleteTeacher(true)
    }

    getClasses(payload = {}) {
        SchoolApi.getClassAndBoard(payload)
            .then(school => {
                let classes = [], boards = []
                for (let i = 0; i < school.classes.length; i++) {
                    classes.push({
                        title: school.classes[i].name,
                        value: school.classes[i].name,
                    })
                }
                for (let i = 0; i < school.boards.length; i++) {
                    boards.push({
                        title: school.boards[i].name,
                        value: school.boards[i].name,
                    })
                }
                const selectedBoard = boards[0].value
                this.setState({ classes, boards, selectedBoard }, _ => {
                    if (this.props?.location?.showAddTeacher) {
                        this.setState({
                            showAddContactModal: true,
                            mode: "CREATE"
                        })
                        this.props.location.showAddTeacher = false
                    }
                })
            }).catch(err => {
            })
    }

    getStaffs(payload = {}) {
        payload.types = `in/MATH_TEACHER,MATH_HOD`;
        payload.getClassDetails = true

        SchoolApi.getStaffs(payload)
            .then(response => {
                this.setState({ adminUsers: response?.response || [] })
            }).catch(err => {
            })

    }

    renderClasses = (classes) => {
        const classObj = {}
        if (classes.length) {
            classes.map((item, index) => {
                if (!classObj[item.class]) classObj[item.class] = []

                classObj[item.class].push(item.section)
            })
        }
        console.log(classObj)
        Object.keys(classObj).map((c) =>  {
            let sections =  classObj[c].map( section => section == 'No Sections' ? '' : section )
            console.log(sections)
            classObj[c] = sections
        })

        return (
            Object.keys(classObj).length ?
                <div className='class-details' data-tip={Object.keys(classObj).map((c) => { return c + `${classObj[c][0] == '' ? '' : '-'}` + classObj[c].join(", ") + "<br />" })}>
                    {
                        Object.keys(classObj).map((c) => {
                            return <div className='class-data'>{c} {classObj[c][0] == '' ? '' : '-' } {classObj[c].join(", ")}</div>
                        })
                    }
                </div>
                :
                <></>
        )
    }

    showSetupSectionModal = (selectedClass, selectedRow) => {
        this.setState({ showSetupSection: true, selectedClass, selectedRow })
    }

    hideSetupSectionModal = isSuccess => {
        this.setState({ showSetupSection: false }, _ => {
            this.getStaffs(this.filter)
            if (isSuccess === true) this.showToaster('info', 'Section added or updated successfully')
            this.addNewContactRef.getSections({ class: this.state.selectedClass }, this.state.selectedRow)
        })
    }

    showAddAdminModal = () => {

        this.setState({ showAddAdminModal: true })
    }

    onCLickEdit = (item, index) => {
        console.log('....', item)
        this.setState({ selectedUser: item, editTeacherIndex: index }, _ => {
            this.onEditTeacherDetails()
        })
    }

    hideAddContactModal = () => {
        this.setState({ showAddContactModal: false, editClassSection: false }, () => {
            this.getStaffs(this.filter)
        })
        if (this.tooltip) {
            this.tooltip.tooltipRef = null
            this.tooltip.hideTooltip()
        }
        ReactTooltip.hide()
    }


    showConfirmModal = (item) => {

        if (!item.classes || !item.classes.length) {
            let deleteMessage = `Are you sure want to remove ${item.firstName} from this school`
            this.setState({ selectedUser: item, showDeleteModal: true, deleteMessage })
        } else {
            this.setState({ selectedUser: item, showConfirmModal: true })
        }
    }

    showAcceptConfirmModal = (item) => {
        let message = `Are you sure, you want to approve ${item.firstName} from this school?`
        this.setState({ selectedUser: item, showAcceptConfirmModal: true, acceptMessage: message })
    }

    showRejectConfirmModal = (item) => {
        let message = `Are you sure, you want to reject ${item.firstName} from this school?`
        this.setState({ selectedUser: item, showRejectConfirmModal: true, rejectMessage: message })
    }

    hideConfirmModal = () => {
        this.setState({ showConfirmModal: false, showDeleteModal: false, showAcceptConfirmModal: false, showRejectConfirmModal: false, emailSendConfirmModal: false })
        if (this.tooltip) {
            this.tooltip.tooltipRef = null
            this.tooltip.hideTooltip()
        }
        ReactTooltip.hide()
    }

    onDeleteTeacher = (isRejected) => {
        let payload = {
            _id: this.state.selectedUser._id
        }
        if (isRejected) {
            payload.status = { type: "REJECTED", displayType: "Rejected" }
            payload.rejectReason = this.state.rejectReason
            payload.rejectDetails = this.state.rejectDetails
        }
        SchoolApi.deleteStaff(payload).then(response => {

            this.payload = {
                limit: this.pageLimit,
                page: 1
            }
            this.getStaffs(this.filter)

            this.hideConfirmModal();

        }).catch(err => {
        })
    }

    approveSchoolUser = () => {
        let payload = { _id: this.state.selectedUser?._id }
        SchoolUserApi.approveUser(payload)
            .then(response => {
                this.getStaffs(this.filter)
                this.hideConfirmModal()
            }).catch(err => {
                console.log(err)
            })
    }

    onDeleteSuccess = () => {

        this.getStaffs(this.filter)

        this.hideConfirmModal();
    }

    bulkImport = () => {
        this.setState({ showBulkImportModal: true })
    }

    hideImport = (refetch) => {
        if (refetch) {
            this.getStaffs(this.filter)
        }
        this.setState({ showBulkImportModal: false })
        if (this.tooltip) {
            this.tooltip.tooltipRef = null
            this.tooltip.hideTooltip()
        }
        ReactTooltip.hide()
    }

    showClassSectionModal = (item) => {
        this.setState({ selectedUser: item, showAddContactModal: true, mode: "EDIT", editTeacherIndex: "", editClassSection: true })
    }

    hideClassSectionModal = () => {
        this.setState({ showClassSectionModal: false }, () => {
            this.getStaffs(this.filter)
        })
        if (this.tooltip) {
            this.tooltip.tooltipRef = null
            this.tooltip.hideTooltip()
        }
        ReactTooltip.hide()
    }

    renderTypes = (item) => {
        return (
            <div>
                {item.types && item.types.map((item, index) =>
                    <div key={index} className='pl-3 pb-2'><span>{item.type.split("_").join(" ")}</span></div>
                )}
            </div>
        )
    }

    showExcelFormat = () => {
        const link = document.createElement('a');
        link.href = 'https://docs.google.com/spreadsheets/d/1dOCC7kf0QJoD8VRlccvg6NguHtl8S1Hd5gka9G8h-K4/edit?usp=sharing';
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    onEditTeacherDetails = () => {
        this.setState({ showAddContactModal: true, mode: "EDIT", editTeacherIndex: "" })
    }

    showAddContactModal = () => {
        this.setState({ showAddContactModal: true, mode: "CREATE" })
    }

    showInviteTeachers = () => {
        this.setState({ showInviteTeachers: true, showAddContactModal: false })
    }


    sendEmail = () => {
        let payload = {
            userId: this.state.inviteUser?._id
        }
        SchoolApi.sendInvite(payload)
            .then(response => {
                this.getStaffs()
                this.hideConfirmModal()
            }).catch(err => {
                console.log(err)
            })
    }

    onClickEmail = (item) => {
        this.setState({ emailSendConfirmModal: true, deleteMessage: "Are you sure want send invitation", inviteUser: item })
    }

    hideInviteTeachers = (success) => {
        if (success === true) this.showToaster('info', 'Message shared successfully on Whatsapp')
        this.setState({ showInviteTeachers: false })
        if (this.tooltip) {
            this.tooltip.tooltipRef = null
            this.tooltip.hideTooltip()
        }
        ReactTooltip.hide()
    }

    onEditTeacherClassAndSection = () => {
        this.showClassSectionModal(this.state.selectedUser)
    }

    onSelectBoard = board => {
        this.setState({
            selectedBoard: board
        })
    }

    onEditTeacherModal() {
        return (
            <div className="cw-card d-inline-block edit-teacher" ref={ref => this.editRef = ref}>
                <div className='p-2' onClick={this.onEditTeacherDetails}>
                    <span>Edit Teacher Details</span>
                </div>

                <div className='p-2' onClick={this.onEditTeacherClassAndSection}>
                    <span>Edit Class or Sections</span>
                </div>
            </div>
        )
    }

    renderAddNewContactModal() {
        return (
            <Modal className="cw-custom-modal add-teachers-modal" isOpen={true} toggle={this.hideAddContactModal} size={"lg"}>
                <ModalBody >

                    <div className="row">
                        <div className="col text-right">
                            <img className="close-icon cursor-pointer" onClick={this.hideAddContactModal} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>
                    <div className="header-text text-right mt-3">
                        <span>{this.state.mode == "CREATE" ? "ADD NEW TEACHER" : this.state.editClassSection ? "ADD CLASS & SECTION" : "EDIT TEACHER"}</span>
                        {/* <span className='invite-link cursor-pointer mr-2 mb-2' onClick={this.showInviteTeachers}>INVITE TEACHERS VIA WHATSAPP</span> */}
                    </div>
                    <div className="px-4">
                        <AddNewContact hideDefaultType ref={ref => this.addNewContactRef = ref} 
                        show={this.state.showAddContactModal} 
                        selectedUser={this.state.selectedUser} 
                        onClose={this.hideAddContactModal} size={'lg'} 
                        mode={this.state.mode} 
                        classes={this.state.classes} 
                        boards={this.state.boards} 
                        showSetupSectionModal={this.showSetupSectionModal} from="teacher-list" 
                        onSelectBoard={this.onSelectBoard} />
                    </div>
                </ModalBody>
            </Modal>)
    }

    renderSetupSection() {
        return (
            <Modal className="cw-custom-modal modal-setup-section" isOpen={true} toggle={this.hideSetupSectionModal} size={"lg"}>
                <ModalBody >

                    <div className="row">
                        <div className="col text-right">
                            <img className="close-icon cursor-pointer" onClick={this.hideSetupSectionModal} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>
                    {/* <div className="header-text text-center">
                        <span>SETUP SECTIONS FOR {this.state.selectedClass.toUpperCase()}</span>
                    </div> */}
                    <div className="px-4">
                        <SetupSection from="teachers" onClose={this.hideSetupSectionModal} class={this.state.selectedClass} board={this.state.selectedBoard} />
                    </div>
                </ModalBody>
            </Modal>
        )
    }

    renderRejectPopup() {
        const { rejectReason, rejectDetails, isValidForm, isSubmit, showError } = this.state
        return (
            <Modal className="cw-custom-modal reject-modal" isOpen={true} toggle={this.hideConfirmModal} size={"lg"}>
                <ModalBody >
                    <div className="row">
                        <div className="col text-right">
                            <img className="close-icon cursor-pointer" onClick={this.hideConfirmModal} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>
                    <div className="reject-modal-body">
                        <div className="title">Reject Reason </div>
                        <div className='row'>
                            <div className='col'>
                                <Dropdown
                                    text='value'
                                    placeholder='Select Reject Reason'
                                    options={REJECT_REASONS}
                                    invalid={showError && !rejectReason}
                                    onSelect={option =>
                                        this.onSelect(option, 'rejectReason')
                                    }
                                    value={rejectReason}
                                    style={{ background: '#F6F7F5' }}
                                />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <textarea className="message-input" placeholder='Enter any other details'
                                    value={rejectDetails}
                                    onChange={(e) => this.onChangeHandler(e, 'rejectDetails')} />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col text-center mt-4'>
                                {this.state.errorMessage ? <div className="text-danger"><strong>{this.state.errorMessage} </strong></div> : ""}
                                <button className={`cw-button-primary ${(!isValidForm || isSubmit) ? "disable-button" : ""}`} onClick={this.onRejectSubmit}>
                                    REJECT
                                </button>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        )
    }

    handleClickEvent = (event) => {
        if (this.editRef && !this.editRef.contains(event.target)) {
            if (this.state.editTeacherIndex >= 0) {
                this.setState({ editTeacherIndex: -1 })
            }
        }
    }

    onFilterGo = (payload = {}) => {
        this.filter = payload
        this.getStaffs(this.filter)
    }

    showToaster(type, message) {
        this.setState(
            {
                showToaster: true,
                toasterMessage: message,
                toasterType: type
            },
            () => {
                setTimeout(() => {
                    this.hideToaster()
                }, 3000)
            }
        )
    }

    hideToaster() {
        this.setState({
            showToaster: false
        })
    }

    render() {
        return (
            <div className='teachers' onScroll={ReactTooltip.hide()}>
                <div className='row'>

                    {/* <div className='col-4'>
                        <span className='screen-title'>TEACHERS</span>
                    </div> */}

                    <div className='col-12 text-right'>

                        <div className='row' >
                            <div className='col'>
                                {this.accessRights[AccessRights.ADD_TEACHER] ? <span>
                                    <button className='cw-btn-md-v1 d-inline-block cw-btn-secondary mr-2' onClick={() => this.showInviteTeachers()} data-tip={"Invite teachers via whatsapp<br />through a shared link"}>
                                        INVITE TEACHERS VIA WHATSAPP
                                    </button>
                                </span> : ""}
                                {this.accessRights[AccessRights.ADD_TEACHER] ? <span>
                                    <button className='cw-btn-md d-inline-block cw-btn-primary mr-2' onClick={() => this.showAddContactModal({}, 'CREATE')} data-tip={"Add New Teacher"}>
                                        ADD NEW TEACHER
                                    </button>
                                </span> : ""}
                                {/* {this.accessRights[AccessRights.BULK_UPLOAD_TEACHER] ?
                                    <span>
                                        <button className='cw-btn-md cw-btn-success ' onClick={() => this.bulkImport()} data-tip={"Import all teachers using excel file"}>
                                            BULK EXCEL UPLOAD
                                        </button>
                                        <br />
                                        <span className='check-text' onClick={this.showExcelFormat}>
                                            <img
                                                className='export-xls'
                                                src={getImageSource(ImageConstants.XLS_BLUE)}
                                            />
                                            Check Format Here
                                        </span>
                                    </span> : ""} */}
                            </div>
                        </div>

                    </div>
                </div>
                <div className='row'>
                    <div className='col'>
                        <FilterComponent onGo={this.onFilterGo} delegate={this} />
                    </div>
                </div>
                {this.state.adminUsers && this.state.adminUsers.length ?
                    <div id="table-scoll" className="table-responsive mt-5">
                        <table className="table table-bordered cw-table mb-0 align-items-center">
                            <thead>
                                <tr>
                                    <th className='th-left-radius'>Name</th>
                                    <th>Email</th>
                                    <th>Mobile Number</th>
                                    <th>Type</th>
                                    <th>Class & Section</th>
                                    <th>Status</th>
                                    <th className='th-right-radius'></th>
                                </tr>
                            </thead>
                            <tbody className="bg-white">
                                {
                                    this.state.adminUsers && this.state.adminUsers.length ? this.state.adminUsers?.map((item, index) => (

                                        <tr key={Math.random()} className={`mt-4 ${item?.status?.type === "TO_BE_APPROVED" ? "to-be-approved" : ""}`} onMouseEnter={ReactTooltip.rebuild}>
                                            <td className='py-5'>
                                                {
                                                    this.accessRights[AccessRights.EDIT_TEACHER] ?
                                                        <div className='name-text cursor-pointer' onClick={() => this.onCLickEdit(item, index)}>
                                                            {item.firstName ? `${item.firstName} ${item.lastName || ''}` : ''}
                                                        </div> :
                                                        <div className=''>
                                                            {item.firstName ? `${item.firstName} ${item.lastName || ''}` : ''}
                                                        </div>
                                                }
                                                {
                                                    this.accessRights[AccessRights.ADD_TEACHER] && item?.status?.type === "TO_BE_APPROVED" &&
                                                    <div>
                                                        <span onClick={_ => this.showAcceptConfirmModal(item)} className='cursor-pointer'>
                                                            <img
                                                                data-tip={"Accept Teacher profile"}
                                                                className='approve-icn'
                                                                src={getImageSource(ImageConstants.GREEN_TICK_V1)}
                                                            />
                                                        </span>
                                                        <span onClick={_ => this.showRejectConfirmModal(item)} className='cursor-pointer'>
                                                            <img
                                                                data-tip={"Reject Teacher profile"}
                                                                className='approve-icn'
                                                                src={getImageSource(ImageConstants.RED_REMOVE)}
                                                            />
                                                        </span>
                                                    </div>
                                                }
                                            </td>
                                            <td className='py-5'>{item?.email}</td>
                                            <td className='py-5'>{item.mobileNumber ? `${item?.countryCode} ${item?.mobileNumber}` : "N/A"}</td>
                                            <td className='py-5'>{this.renderTypes(item)}</td>
                                            <td className='py-5'>{item.classes && item.classes.length ? this.renderClasses(item.classes) :
                                                <div className='cursor-pointer' onClick={() => this.onCLickEdit(item, index)} data-tip={"Assign Class & Section"}>
                                                    <img
                                                        className='add-icn'
                                                        src={getImageSource(ImageConstants.ADD)}
                                                    />
                                                </div>
                                            }
                                            </td>
                                            <td className='py-5'>{item?.status?.typeText}</td>
                                            <td className="text-right edit-td py-5"> {item?.status?.typeText == Constants.SCHOOL_STATUS.INVITE_SENT && this.accessRights[AccessRights.INVITE_CONTACT] ?
                                                <span className="px-2">
                                                    <img className="add-contact cursor-pointer mb-1" onClick={() => this.onClickEmail(item)} src={getImageSource(ImageConstants.ENVELOPE)} data-tip={"Send Invitation"} />
                                                </span>
                                                :
                                                <></>
                                            }
                                                {
                                                    this.accessRights[AccessRights.EDIT_TEACHER] ?
                                                        <>
                                                            <span className="px-2">
                                                                <img className="add-contact cursor-pointer mb-1" onClick={() => this.onCLickEdit(item, index)} src={getImageSource(ImageConstants.EDIT)} data-tip={"Edit Teacher"} />
                                                            </span>

                                                        </> : ""
                                                }
                                                {
                                                    this.user.id != item._id && this.accessRights[AccessRights.DELETE_TEACHER] ?
                                                        <span className="px-2">
                                                            <img className="add-contact cursor-pointer" onClick={() => this.showConfirmModal(item)} src={getImageSource(ImageConstants.DELETE_RED)} data-tip={"Delete Teacher"} />
                                                        </span>
                                                        : ""
                                                }
                                            </td>
                                        </tr>
                                    ))
                                        : <tr className="bg-white pt-4"><td colSpan="11" align='center'>No Records found</td></tr>
                                }
                            </tbody>
                        </table>
                    </div >
                    :

                    <div className='row no-record-container'>
                        <div className='col'>
                            <div className='text-center'><img className='no-record-image' src={getImageSource(ImageConstants.NO_RECORDS)} /></div>
                            <div className='text-center pt-2'><text >No teachers added currently!</text></div>
                        </div>
                    </div>

                }
                {/* {this.state.showAddContactModal && <AddNewContact show={this.state.showAddContactModal} selectedUser={this.state.selectedUser} mode={this.state.mode} onClose={this.hideAddContactModal} size='lg' />} */}
                {this.state.showConfirmModal && <DeleteTeacher close={this.hideConfirmModal} teacher={this.state.selectedUser} onOk={this.onDeleteSuccess.bind(this)} />}
                {this.state.showDeleteModal && <CWConfirm close={this.hideConfirmModal} message={this.state.deleteMessage} onOk={this.onDeleteTeacher.bind(this)} />}
                {this.state.showClassSectionModal && <CWClassSection show={this.state.showClassSectionModal} selectedUser={this.state.selectedUser} onClose={this.hideClassSectionModal} mode={this.state.mode} size='lg' />}
                {this.state.showBulkImportModal && <ContactBulkImport mode={this.state.mode} size={'lg'} onClose={this.hideImport} title="ADD TEACHERS" />}
                {this.state.showAddContactModal && this.renderAddNewContactModal()}
                {this.state.showInviteTeachers && <InviteTeachers type={"teacher"} onClose={this.hideInviteTeachers} />}
                {this.state.emailSendConfirmModal && <CWConfirm modal={this.state.emailSendConfirmModal} close={this.hideConfirmModal} message={this.state.deleteMessage} onOk={this.sendEmail.bind(this)} />}
                {this.state.showAcceptConfirmModal && <CWConfirm modal={this.state.showAcceptConfirmModal} close={this.hideConfirmModal} message={this.state.acceptMessage} onOk={_ => this.approveSchoolUser(true)} />}
                {this.state.showRejectConfirmModal && this.renderRejectPopup()}
                {this.state.showSetupSection && this.renderSetupSection()}
                {this.state.showToaster ? (
                    <div className='custom-toaster-modal'>
                        <ToasterComponent message={this.state.toasterMessage} type={this.state.toasterType} position="bottom-center" />
                    </div>
                ) : (
                    ''
                )}
                <ReactTooltip ref={el => this.tooltip = el} multiline={true} place='bottom' type='dark' effect='solid' event="mouseover mouseenter" eventOff="mouseleave mouseout scroll mousewheel blur" />
            </div>

        )
    }

}

export default Teachers;